export default "__VITE_ASSET__CK3DST8___"